export default {
  unknownText: 'Unknown',
  noText: '-',
};
